export const storyComment = `
id
storyId
creatorId
content
updatedAt
createdAt
`
